import { httpClient } from '../lib/http-client';
import { Unidade } from '../types';

/**
 * Service para gerenciamento de unidades
 */
export class UnidadesService {
  static async getUnidades(): Promise<Unidade[]> {
    return httpClient.get<Unidade[]>('/api/unidades');
  }

  static async getUnidade(id: number): Promise<Unidade> {
    return httpClient.get<Unidade>(`/api/unidades/${id}`);
  }

  static async createUnidade(data: Partial<Unidade>): Promise<Unidade> {
    return httpClient.post<Unidade>('/api/unidades', data);
  }

  static async updateUnidade(id: number, data: Partial<Unidade>): Promise<Unidade> {
    return httpClient.put<Unidade>(`/api/unidades/${id}`, data);
  }

  static async deleteUnidade(id: number): Promise<{ success: boolean }> {
    return httpClient.delete<{ success: boolean }>(`/api/unidades/${id}`);
  }

  static async toggleUnidadeStatus(id: number): Promise<{ ativo: number }> {
    return httpClient.patch<{ ativo: number }>(`/api/unidades/${id}/toggle-status`);
  }
}

